import { httpFetch } from "../Utils/httpUtils";
import { priceSimulationActionTypes as actionTypes } from "../ActionTypes/priceSimulationActionTypes";
import { commonActionTypes } from "../ActionTypes/commonActionTypes";

const priceSimulationActions = {
    getPackages: () => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "packages", value: true });
            
            return httpFetch(`/api/price-simulations/packages/`, dispatch)
                .then(json => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "packages", value: false });
                    dispatch({ type: actionTypes.STORE_PRICE_SIMULATION_PACKAGES, data: json });
                })
        }
    },

    fetchPriceSimulationPackageContextBeta: (id) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: `package_${id}`, value: true });
            
            return httpFetch(`/api/price-simulations/packages/${id}/context`, dispatch)
                .then(json => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: `package_${id}`, value: false });

                    const packageData = json.package;
                    dispatch({ type: actionTypes.STORE_PRICE_SIMULATION_PACKAGE_CONTEXT, packageId: id, data: packageData });

                    if (json.package) {
                        dispatch({
                            type: actionTypes.STORE_PRICE_SIMULATION_METADATA,
                            packageId: id,
                            hasActiveProposal: json.hasActiveProposal ?? false,
                            isOutdatedVersion: json.isOutdatedVersion ?? false,
                        });
                    }
                })
        }
    },

    fetchReviewers: () => {
        return (dispatch) => {
            return httpFetch('/api/price-simulations/reviewers', dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_REVIEWERS, data: json });
                });
        }
    },

    submitForApproval: (payload) => {
        return (dispatch) => {
            const httpRequest = {
                method: 'POST',
                body: JSON.stringify(payload),
            };
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'submitApproval', value: true });

            return httpFetch('/api/price-simulations/proposals/submit-for-approval', dispatch, httpRequest)
                .then(json => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'submitApproval', value: false });
                    dispatch({ type: actionTypes.SUBMIT_FOR_APPROVAL_SUCCESS });
                    return json;
                })
                .catch(err => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'submitApproval', value: false });
                    throw err;
                });
        }
    },

    saveDraftProposals: (packages) => {
        return (dispatch) => {
            const httpRequest = {
                method: 'PUT',
                body: JSON.stringify({ packages }),
            };
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'saveDraft', value: true });

            return httpFetch('/api/price-simulations/proposals', dispatch, httpRequest)
                .then(json => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'saveDraft', value: false });
                    dispatch({ type: actionTypes.SAVE_DRAFT_PROPOSALS, packages });
                    return json;
                })
                .catch(err => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: 'saveDraft', value: false });
                    throw err;
                });
        }
    },
};

export default priceSimulationActions;
